module.exports = __webpack_public_path__ + "components/resort-guide/static/icon-beginner--black-6cf80748dd1e78e19bdf5011fedf4091.svg";